<template>
  <div>
    <CCard>
      <div class="card-body">
          <h2 class="card-title">Deposit funds to your 7XL account via Bitcoin</h2>
          <p v-if="rate">Current reference exchange rate {{rate}} USD/BTC</p>
         <form v-if="!orderMessage">
          <div class="form-group">
            <label for="exampleFormControlInput1">7XL Username </label>
            <input type="email"  class="form-control" v-model="username" placeholder="Your 7XL USERNAME">
          </div>
            <CButton color="success" block @click='orderDeposit()'>Order Deposit</CButton>
         </form>
         <div v-if="orderMessage"  v-html="orderMessage" class="text-center"></div>
         <CButton v-if="orderMessage" color="success" @click='makeAnother()'>Make Another Deposit</CButton>
     </div>
    </CCard>

    <CRow>
      <CCol sm="12">
        <CTableWrapper :items="logItems" :fields="logFields">
          <template #header>
            <CIcon name="cil-grid"/> Operations Log  
            <CButton color="info" size="sm" variant='outline' shape='pill' @click='loadLog()'>refresh</CButton> 
            <span v-if="loadingItems" > Loading List...</span>
          </template>
        </CTableWrapper>
      </CCol>
    </CRow>
  </div>
</template>

<script>

import CTableWrapper from './base/Table.vue' 
export default {
  name: 'Dashboard',
  components: {
     CTableWrapper 
  },
  data () {
    return {
       rate: false,
       username: '',
       orderMessage: false,
       ref_code: '',
       wallet: '',
       opt: '',
       loadingItems: false,
       logItems: [],
       logFields: [
         'wallet'
       ]
    }
  },
  methods: {

      orderDeposit(){
        let self = this;
        this.$api
          .post('deposit/btc', {
            account: this.username
          })
          .then(function (responce){
               self.$toast.open('Done!');
               self.orderMessage =  responce.data.message;
               self.opt =  responce.data.opt;
               self.ref_code =  responce.data.ref_code;
               self.wallet =  responce.data.wallet;
               self.loadLog();
          });
      },
      makeAnother (){
               this.orderMessage =  false;
               this.opt =  '';
               this.ref_code =  '';
               this.wallet =  '';
      },
      loadRate(){
       let self = this;
          this.$api
          .get('https://api.up24.biz/api/v1/bitstamp')
          .then(function (responce){
               self.rate = responce.data.last;
          });
      },
      loadLog(){
       let self = this;
       self.loadingItems = true;
          this.$api
          .get('log')
          .then(function (responce){
               self.logItems = responce.data.items;
               self.loadingItems = false;
          });
      }
    },
    mounted: function () {

     let self = this; 
       self.loadRate();
       self.loadLog();
        setInterval(function(){
            self.loadLog();
        }, 20000);
     
  } 
}
</script>
<style>
.btn.clip-btn{
  display: none;
}
</style>
